<script setup lang="ts">
import { InputField, InputTextarea } from '@caks/uikit/input'
import { IiPickupMap } from '@caks/shared/modules/ii'
import { IconLocation } from '@caks/uikit/icon'
import { ButtonMain } from '@caks/uikit/button'
import {
  getCitiesIds,
  getDadataStreet,
  getPickupPoints,
  postNewAddress,
} from '@caks/shared/api/user.route'
import { useAccountStore } from '@caks/shared/store/store.account'
import { CitiesEnum } from '@caks/shared/types/types.api'
import { DropdownMain } from '@caks/uikit/dropdown'
import { DropdownOption } from '@caks/shared/types/types.ui-kit'
import { reactive } from 'vue'

const coordinates = ref([])
const coordinatesLon = ref(0)
const coordinatesLat = ref(0)

const accountStore = useAccountStore()
const emit = defineEmits<{ (e: 'add-address'): void }>()

const dataAddress = reactive({
  street: '',
  entry: '',
  house_number: '',
  floor: '',
  apartment: '',
  comment: '',
  city_code: '',
  lon: '',
  lat: '',
})

const citiesEnum = ref<CitiesEnum>()
const citiesOptions = ref<DropdownOption[]>([])
const selectedCity = ref<DropdownOption>()

const onSelectCity = async (option: DropdownOption) => {
  store.city = option.name
  localStorage.setItem('caksCity', option.name)

  selectedCity.value = option
  dataAddress.city_code = selectedCity.value.id
  console.log(option)

  if (option.name === 'Пятигорск') {
    coordinatesLon.value = 43.06634848361048
    coordinatesLat.value = 44.050784160020704
  }
  if (option.name === 'Ессентуки') {
    coordinatesLon.value = 42.88265361205761
    coordinatesLat.value = 44.04526243026669
  }
  if (option.name === 'Ставрополь') {
    coordinatesLon.value = 41.96274486723304
    coordinatesLat.value = 45.04008128995268
  }
  if (option.name === 'Кисловодск') {
    coordinatesLon.value = 42.71571828995268
    coordinatesLat.value = 43.90551828995268
  }
  if (option.name === 'Минеральные') {
    coordinatesLon.value = 43.139086897111525
    coordinatesLat.value = 44.20967236143895
  }
}
const store = useAccountStore()

onMounted(async () => {
  const { data } = await getPickupPoints(Number(accountStore.cityId))
  for (const point in data) {
    //@ts-ignore
    if (data[point].cityId === accountStore.cityId) {
      //@ts-ignore
      coordinates.value.push({ lon: data[point].lon, lat: data[point].lat })
    }
  }

  const { data: citiesIds } = await getCitiesIds()
  citiesEnum.value = citiesIds

  for (const city in citiesIds) {
    citiesOptions.value.push({
      id: citiesIds[city as keyof CitiesEnum],
      name: city,
    })
  }

  console.log(citiesOptions.value)
  selectedCity.value = citiesOptions.value.find((el) => el.name === store.city)
  dataAddress.city_code = selectedCity.value.id

  if (selectedCity.value) {
    if (selectedCity.value.name === 'Пятигорск') {
      coordinatesLon.value = 43.06634848361048
      coordinatesLat.value = 44.050784160020704
    }
    if (selectedCity.value.name === 'Ессентуки') {
      coordinatesLon.value = 42.88265361205761
      coordinatesLat.value = 44.04526243026669
    }
    if (selectedCity.value.name === 'Ставрополь') {
      coordinatesLon.value = 41.96274486723304
      coordinatesLat.value = 45.04008128995268
    }
    if (selectedCity.value.name === 'Кисловодск') {
      coordinatesLon.value = 42.712763
      coordinatesLat.value = 43.90138
    }
    if (selectedCity.value.name === 'Минеральные') {
      coordinatesLon.value = 43.139086897111525
      coordinatesLat.value = 44.20967236143895
    }
  }
})

const isButtonDisabled = computed(() => {
  return !(dataAddress.street && dataAddress.entry && dataAddress.house_number && dataAddress.floor)
})

const onSave = async () => {
  const { data } = await getDadataStreet(
    dataAddress.city_code,
    dataAddress.street,
    dataAddress.house_number
  )

  const { city, lat, lon } = data[0]
  dataAddress.lon = lon
  dataAddress.lat = lat

  const { code } = await postNewAddress(dataAddress)

  if (code === 0) emit('add-address')
}

watch(coordinatesLon, () => {
  console.log(coordinatesLon.value, coordinatesLat.value)
})
</script>

<template>
  <div class="new-address-wrapper">
    <div class="new-address">
      <h3 class="new-address__title">Добавить адрес</h3>
      <dropdown-main
        :model-value="selectedCity"
        :options="citiesOptions"
        @update:model-value="onSelectCity"
      />
      <input-field
        v-if="citiesEnum"
        v-model="dataAddress.street"
        placeholder="Укажите улицу"
        no-icons
        da-data
        :city-id="citiesEnum[accountStore.city as keyof typeof citiesEnum]"
        :required="true"
      />
      <div class="new-address__location">
        <icon-location />
        Определить местоположение
      </div>
      <div class="new-address__details">
        <input-field v-model="dataAddress.entry" placeholder="Подъезд" no-icons :required="true" />
        <input-field
          v-model="dataAddress.house_number"
          placeholder="Дом"
          no-icons
          :required="true"
        />
        <input-field v-model="dataAddress.floor" placeholder="Этаж" no-icons :required="true" />
        <input-field v-model="dataAddress.apartment" placeholder="Квартира" no-icons />
        <input-textarea v-model="dataAddress.comment" placeholder="Комментарий к адресу" no-icons />
      </div>
      <button-main :disabled="isButtonDisabled" @click="onSave">Сохранить</button-main>
    </div>
    <ii-pickup-map
      :coordinates-lat="coordinatesLat"
      :coordinates-lon="coordinatesLon"
      :points="coordinates"
      class="new-address__map"
      desktop
    />
  </div>
</template>

<style scoped lang="scss">
.new-address-wrapper {
  display: flex;
  height: 548px;
  width: 864px;
}

.new-address {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 32px;

  &__title {
    @include h2-1;
  }

  &__location {
    display: flex;
    gap: 4px;
    align-items: center;
    color: $primary-green;
    --svg-col: #{$primary-green};
    cursor: pointer;
    @include h4-7;
  }

  &__details {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;

    :nth-child(1) {
      grid-area: 1 / 1 / 2 / 2;
    }
    :nth-child(2) {
      grid-area: 1 / 2 / 2 / 3;
    }
    :nth-child(3) {
      grid-area: 2 / 1 / 3 / 2;
    }
    :nth-child(4) {
      grid-area: 2 / 2 / 3 / 3;
    }
    :nth-child(5) {
      grid-area: 3 / 1 / 4 / 3;
    }
  }

  button:last-child {
    margin-top: auto;
  }

  &__map {
    height: 100%;
    width: 100%;
    border-radius: 0 16px 16px 0;
    overflow: hidden;
  }
}
</style>
